import { Grid } from '@mui/material';
import { AnnualPercentYieldForm } from './annualPercentForm';
import { InitialDepositForm } from './InitialDepositForm';
import { MonthlyDepositForm } from './monthlyDepositForm';
import { TimePeriodForm } from './timePeriodForm';

export function CalculatorForm() {
  return (
    <Grid
      container
      component="form"
      data-testid="calculator-form"
      spacing={0}
      sx={{
        backgroundColor: 'background.default',
        gap: '1rem',
      }}
    >
      <Grid size={{ xs: 12, sm: 'grow' }}>
        <InitialDepositForm />
      </Grid>
      <Grid size={{ xs: 12, sm: 'grow' }}>
        <MonthlyDepositForm />
      </Grid>
      <Grid size={{ xs: 12, sm: 'grow' }}>
        <AnnualPercentYieldForm />
      </Grid>
      <Grid size={{ xs: 12, sm: 'grow' }}>
        <TimePeriodForm />
      </Grid>
    </Grid>
  );
}
